































import { Component, Vue } from 'vue-property-decorator'

import BusinessRegistrationIntroIcon from '../components/BusinessRegistrationIntroIcon.vue'
import { CompanyRegistrationStep } from '../types'

@Component({
  components: {
    BusinessRegistrationIntroIcon,
  },

  data: () => ({
    CompanyRegistrationStep,
  }),
})
export default class Greeting extends Vue {

  tgBot = this.$store.state.AdminTemplate?.applicationConfig.meta.tgResolvers.mainBotDomain

  onProjectName(): string {
    const projectName = this.$store.state.AdminTemplate?.applicationConfig.meta.projectName
    return projectName !== undefined ? projectName : 'TESTBOT'
  }
}
